import { EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var PreviewComponent = (function () {
    function PreviewComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.outPutClosePreview = new EventEmitter();
        this.startScreen = false;
        this.isImgLoading = false;
    }
    PreviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log(this.previewSource);
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewSource['fileUrl']);
        setTimeout(function () {
            _this.startScreen = true;
        }, 300);
        setTimeout(function () {
            _this.isImgLoading = true;
        }, 500);
    };
    PreviewComponent.prototype.ngAfterViewInit = function () {
        setTimeout(function () {
            $('.preview-body').eq(0).find('iframe').height($(window).height() - 44);
        });
    };
    PreviewComponent.prototype.close = function () {
        this.startScreen = false;
        this.outPutClosePreview.emit();
    };
    return PreviewComponent;
}());
export { PreviewComponent };



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-preview/preview.component.ts.pre-build-optimizer.js